import { Documento, type NodoDoc } from "@/componentes/documentos/Documento"
import { EncabezadoEmpresa } from "@/componentes/empresa/EncabezadoEmpresa"

/**
 * La hoja de un documento de Talento Humano: membrete, título y texto.
 *
 * ⚠ **El membrete es el de siempre** (`EncabezadoEmpresa`), como el manual y la
 * Biblioteca: escribir aquí razón social y RIF sería un segundo membrete que se queda
 * viejo al cambiar el logo.
 *
 * ⚠ **El texto es el CONGELADO del documento**, no el de la plantilla de hoy: lo que se
 * imprime es lo que se entregó.
 */
export function HojaDocumentoTH({
  codigo,
  titulo,
  fecha,
  cuerpo,
}: {
  codigo?: string
  titulo: string
  fecha?: string
  cuerpo: NodoDoc
}) {
  return (
    <article className="doc-prosa">
      <EncabezadoEmpresa titulo={codigo ?? titulo} fecha={fecha} />
      {/* No es un `h2`: en `.doc-prosa` los `h2` se numeran, y el título no es la
          cláusula 1. */}
      <p className="mt-4 mb-2 text-center text-lg font-bold uppercase">{titulo}</p>
      <Documento cuerpo={cuerpo} />
    </article>
  )
}
